<template>
  <div class="col-lg-12" style="padding:20px;">
    <div class="main-card mb-3 card" style="margin-left: 10px;">
      <div class="card-body">
          <h5 class="card-title" >사업설명회
            <div class="sub_title"
            style="margin-bottom: 20px; color: #333; font-size: 13px; border: 1px solid #ccc; background: #f8f8f8; height: 30px; text-align: right; position: absolute; right: 20px; top: 10px; padding: 2px 10px;">
              신청관리 → 사업설명회
            </div>
          </h5>
        <query-grid :config="config" ref="qg">
          <template #actions>
            <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg-inst"
              @click="creatingMode()">일정 등록</button>

                          <router-link to="attendants"><button type="button" class="btn btn-info" >전체 신청자 보기</button></router-link>
            <!--button class="btn btn-success ">엑셀저장</button-->
          </template>
          <template #items="props">
<tr v-for="record in props.records" v-bind:key="record.id" :class="{'table-danger': record.is_deleted}" >
  <td scope="col"><input type="checkbox" v-model="record.checked"></td>
              <td scope="row" style="text-align:center;">{{ record.id }}</td>

              <td style="text-align:center;"><!--a href="#" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
                  @click="moreStudentInfo(record)">{{ record.username }}</a-->
                  {{ record.open_time }}
                  </td>

              <td style="text-align:center;">
                  {{ record.name }}
                  </td>
              <td style="text-align:center;"  >
                <span v-if="record.status == 0">마감</span>
                <span v-if="record.status == 1">접수중</span>
                <span v-if="record.status == 2">취소</span>
</td>
                <td style="text-align:center;"> {{ record.created_at }}

              </td>
              <td style="text-align:center;">{{ record.due_by }}</td>
              <td style="text-align:center;"><Admin :admin="{'id': record.added_by, 'name': record.added_by_name}" />
              </td>
              <td style="text-align:center;">{{ record.cnt }}</td>
              <td style="text-align:center;">
                <button class="btn btn-secondary btn-sm" style="padding:2px 4px; font-size:12px;" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg-inst" @click="modifyingMode(record)">수정</button>
                <router-link :to="'/requests/franchise_meetings/plans/' + record.id + '/attendants'"><button class="btn btn-info btn-sm" style="padding:2px 4px; font-size:12px;">신청자 조회</button></router-link>
              </td>

            </tr>
          </template>

        </query-grid>

        <div class="modal fade bd-example-modal-lg-inst" tabindex="-1" role="dialog" id="studentModal"
          aria-labelledby="myLargeModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">일정 관리</h5>
              </div>
              <div class="modal-body" >

                <div>
                  <div style="display: inline-block; padding: 10px 0 20px; float: right; margin-right: 30px;">


                    <!--button type="button" class="btn btn-primary" style="font-size: 14px!important;"
                      v-if="!creating">학습부여</button-->
                  </div>

                  <div class="card-header" style="clear:both; background:#fff;">
                    <div class="btn-actions-pane-right">
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="tab-content">
                      <div class="" id="tab-eg2-0" role="tabpanel">
                        <p>
                          <table class="table">
                      <colgroup>
                        <col style="width:20%;" />
                        <col style="width:30%;" />
                        <col style="width:20%;" />
                        <col style="width:30%;" />
                      </colgroup>
                            <tbody>
                              <colgroup>
                                <col width="">
                              </colgroup>
                              <tr>
                                <th>일정명</th>
                                <td>
                                  <input class="hidtype" v-model="selData.name" placeholder="일정명" />
                                </td>
                                <th>상태</th>
                                <td>
                                    <select v-model="selData.status">
                                        <option value="0">마감</option>
                                        <option value="1">접수중</option>
                                        <option value="2">취소</option>

                                    </select>
                                </td>

                              </tr>
                              <tr>
                                <th>일정 시간</th>
                                <td>
                                    <input class="hidtype" v-model="selData.open_time" type="datetime-local" style="width:160px;" />
                                </td>
                                <th>신청 마감 시한</th>
                                <td>
                                    <input class="hidtype" v-model="selData.due_by" type="datetime-local" style="width:160px;" />
                                </td>
                              </tr>
                            </tbody>
                          </table>

                        </p>
                        <div class="modal-footer flex_center">
                          <button type="button" class="btn btn-warning" @click="doSend()" >일정 등록</button>
                        </div>

                      </div>

                    </div>
                  </div>






                </div>
              </div>

            </div>
          </div>
        </div>


      </div>
    </div>
  </div>


</template>

<script>
  // @ is an alias to /src

  import Admin from "../components/detail_pages/Admin";
  import QueryGrid from "../components/QueryGrid";
  import axios from "axios";
  export default {
    name: 'Home',
    components: {
      Admin,
      QueryGrid
    },
    mounted() {

        this.$refs.qg.pushSetting("status_filter_OPEN", true);

      this.$refs.qg.search();


    },
    methods: {
      doSend() {
        // 업데이트일 경우 patch /businesses/번호
        // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
        var data = {
            'name': this.selData.name,
            'open_time': this.selData.open_time,
            'due_by': this.selData.due_by,
            'status': this.selData.status,
        }
        axios({
          method: this.creating ? "post" : "patch",
          url: '/requests/franchise_meetings/plans' + (!this.creating ? "/" + this.selData.id : ""),
          data: data
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '처리할 수 없습니다 ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.$refs.qg.search()
            $.notify({
              // options
              message: '일정 생성이 처리되었습니다'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            (bootstrap.Modal.getInstance(document.getElementById("studentModal"))).hide();


          }


        })


      },
      fetchProducts(source) {
        var extras = "?";
        if (source) {
          extras += "source=" + source.id
        }
        axios.get('/products' + extras).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.products = response.data.result;
          }


        })
      },

              fetchSubscriptions(student) {
        var extras = "";
        //this.levelRequest.record = {};
        axios.get('/subscriptions?status_filter=[\"ACTIVE\"]&student=' + student.id).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            student.subscriptions = response.data.result.filter(x => x.product == 'MYUSE');
          }


        })
      },
      fetchSubscriptionsChecked(){
        this.$refs.qg.checked.forEach((s) => {
          this.fetchSubscriptions(s);
        })
      },
      getDiff(value) {

        var moment = require('moment'); // moment 모듈불러오기

        const diff = moment().diff(value, 'hours');
        const days = Math.floor(diff / 24);
        const hours = diff % 24;

        return -days;

      },
      creatingMode() {
        this.selData = {
          "open_time": "",
          "name": "",
          "status": 1,
          "due_by": ""
        };
        this.creating = true;
      },
      modifyingMode(record) {
        this.selData = {
            ...record,
            due_by: record.due_by.replace(" ", 'T'),
            open_time: record.open_time.replace(" ", 'T'),

        };
        this.creating = false;
      }
    },
    data() {
      return {
        config: {
    "name": "가맹설명회 일정 리스트",
    "req_endpoint": "/requests/franchise_meetings/plans",
    "default_limit": 20,
    "search_fields": [
        {
            "id": "status_filter",
            "name": "상태",
            "type": "switch",
            "filter_type": {
                "CLOSED": "마감",
                "OPEN": "접수 중",
                "CANCELLED": "취소됨"
            }
        },
        {
            "id": "search",
            "name": "키워드검색",
            "type": "text",
            "placeholder": "번호/이름/생성관리자이름/생성관리자번호"
        },
        {
            "id": "date_filter",
            "name": "날짜검색",
            "type": "date",
            "filter_type": {
                "open_time": "일정 날짜",
                "due_by": "신청 기한",
                "created_at": "일정 생성일"
            }
        }
    ],
    "columns": [
              {
            "id": "chkbox",
            "name": "체크",
            "is_check": true
        },
        {
            "id": "id",
            "sortable": true,
            "name": "번호",
            "excel_print": v=>{return v.id}
        },
        {
            "id": "open_time",
            "sortable": true,
            "name": "진행 날짜",
            "excel_print": v=>{return v.open_time}
        },
        {
            "id": "name",
            "sortable": true,
            "name": "이름",
            "excel_print": v=>{return v.name}
        },
        {
            "id": "status",
            "sortable": true,
            "name": "상태",
            "excel_print": v=>{var a={0: "마감", 1: "접수 중", 2: "취소됨"};return a[v.status]}
        },
                {
            "id": "created_at",
            "sortable": true,
            "name": "생성일",
            "excel_print": v=>{return v.created_at}
        },
                        {
            "id": "due_by",
            "sortable": true,
            "name": "신청 기한",
            "excel_print": v=>{return v.due_by}
        },
                        {
            "id": "added_by",
            "sortable": true,
            "name": "생성 관리자명",
            "excel_print": v=>{return v.added_by_name}
        },
        {
            "id": "cnt",
            "sortable": true,
            "name": "신청인원",
            "excel_print": v=>{return v.cnt}
        },
        {
            "id": "act",
            "name": "액션",
        }
    ],
    disable_init_search: true
},
        selBiz: {
          "name": ""
        },
        subscriptions: [],
        selData: {
          "open_time": "",
          "name": "",
          "status": 1,
          "due_by": ""

        },
        selProduct: {

        },
        selectedSubscription: {
          id: 0
        },
        products: [],
        creating: true
      }
    }
  }
</script>
